import axios from "axios";
import _ from "lodash";
import { Notification } from 'element-ui'

const state = {};

const mutations = {};

const actions = {
  async list(context, params) {
    try {
      const { data } = await axios.get("/car-repair", {
        params
      });

      return data
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro de carregamento',
        message: _.get(
          err,
          "response.message",
          "Não foi possível carregar as oficinas"
        ),
        duration: 6000,
      });
    }
  },


  async update(context, { id, carRepair }) {
    try {
      const { data } = await axios.put("/car-repair/" + id, carRepair);

      return data;
    } catch (err) {
      console.log(err)
      Notification({
        type: 'error',
        title: 'Erro ao atualizar',
        message: _.get(
          err,
          "response.data.error",
          "Não foi possível atualizar a oficina"
        ),
        duration: 6000,
      });
    }
  },

  async create(context, carRepair) {
    try {
      const { data } = await axios.post("/car-repair", carRepair);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao criar',
        message: _.get(
          err,
          "response.data.error",
          "Não foi possível criar a oficina"
        ),
        duration: 6000,
      });
    }
  },

  async delete(context, carRepairId) {
    try {
      const { data } = await axios.delete("car-repair/" + carRepairId);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao deletar',
        message: _.get(
          err,
          "response.data.error",
          "Não foi possível deletar a oficina"
        ),
        duration: 6000,
      });
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
